<template>
  <div class="video_list">
    <div class="list-box" v-if="videoList && videoList.length">
      <div
        class="item"
        v-for="itemVideo in videoList"
        :key="itemVideo.id"
        @click="clickVideo(itemVideo)"
      >
        <div class="img_box">
          <img class="img" :src="itemVideo.snapshot" />
          <div class="foot">
            <cl-avatar
              class="avatar"
              :width="22"
              :height="22"
              :src="itemVideo.user_avatar"
              :name="itemVideo['user_name']"
            />
          </div>
        </div>
        <div class="info" @click.stop>
          <div class="name">
            <div style="width: calc(100% - 10px)" class="text_wrapper">
              <cl-overflow-tooltip parent-class-name="text_wrapper">
                {{ itemVideo.name }}
              </cl-overflow-tooltip>
            </div>
          </div>
          <p class="time AkrobatR">
            {{ $moment(itemVideo.createTime).format("YYYY/MM/DD HH:mm") }}
          </p>
        </div>
        <div class="line"></div>
      </div>
    </div>
    <el-dialog
      :title="currentVideo.name"
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose"
      class="video_dialog"
      top="30%"
    >
      <div class="video_title" @click="handleClose">
        <cl-svg-icon
          width="16"
          height="16"
          icon-class="page_back_white"
          class="mr4"
        ></cl-svg-icon>
        <span>{{ currentVideo.name }}</span>
      </div>
      <video
        :src="currentVideo.url"
        controlslist="nodownload"
        autoplay
        controls
        width="100%"
        height="598"
        class="video"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    videoList: {},
  },
  data() {
    return {
      dialogVisible: false,
      currentVideo: {},
    };
  },
  methods: {
    clickVideo(item) {
      console.log(item, "item");
      this.currentVideo = item;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.currentVideo = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.video_list {
  width: 100%;
  min-height: 240px;
}
.list-box {
  display: flex;
  flex-flow: wrap;
  align-content: flex-start;
  width: calc(100% + 25px);
  height: 100%;
  padding-bottom: 24px;
  .item {
    position: relative;
    margin-top: 16px;
    margin-right: 16px;
    width: 176px;
    height: 159px;
    background: #fff;
    border-radius: 2px;
    // &:hover {
    //   .line {
    //     opacity: 1;
    //   }
    // }
  }

  .line {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 180px;
    height: 3px;
    border-radius: 6px 6px 0 0;
    background: $base-color-theme;
    opacity: 0;
    transition: opacity 0.5s;
  }

  .info {
    padding-top: 8px;
    box-sizing: border-box;
    .name {
      margin-bottom: 8px;
      font-size: 16px;
      color: #3a3a3a;
      position: relative;
    }
    .time {
      font-size: 14px;
      color: #b7b7bf;
    }
  }
}
.img_box {
  height: 100px;
  position: relative;
  .img {
    border-radius: 2px 2px 0 0;
    width: 100%;
    height: 100px;
  }
  .foot {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 42px;
    height: 42px;
    background: url("~@/assets/images/video/jiao.png") no-repeat;
    background-size: 100% 100%;
    .avatar {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }
  }
}
/deep/.el-dialog__body {
  height: 600px;
  padding: 0 !important;
  position: relative;
  background-color: #000;
  .video {
    background-color: #000;
  }
}
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog {
  margin-top: 2% !important;
}
.video_title {
  position: absolute;
  left: 16px;
  top: 16px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  z-index: 2;
}
</style>
